import { render } from "./RelatedTable.vue?vue&type=template&id=9ad74368&scoped=true"
import script from "./RelatedTable.vue?vue&type=script&lang=js"
export * from "./RelatedTable.vue?vue&type=script&lang=js"

import "./RelatedTable.vue?vue&type=style&index=0&id=9ad74368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad74368"]])

export default __exports__